/* Built In Imports */
import React, { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import YogaCommonUI from '@components/UI/Yoga/YogaCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import {
    getLocale
} from '@components/Utility/Shared/SharedService';
import {
    fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData, filterBuildUrls,
    getLatestBuild
} from 'services/commonService';
import {
    fetchExclusivePageData
} from 'services/exclusiveService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Exclusive Sub Page Data
 */
const ExclusiveSubPage = ({ region, language, pageData }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);
  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box
        as="section"
        className="page-wrap container-article"
        padding={{ base: '15px', md: '0' }}
      >
        <YogaCommonUI
          pageBody={pageData.body}
          region={region}
          lang={language}
        />
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  let exclusiveLandingPath =
    config.USE_LOCAL_URL || config.BUILD_URLS?.LANDING_PAGES?.SadhguruExclusive
      ? [`/in/en/sadhguru-exclusive/terms-conditions`]
      : [];

  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    let data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    exclusiveLandingPath = filterBuildUrls(
      'others_section',
      'L1',
      '/sadhguru-exclusive/terms-conditions',
      '',
      data
    );
    // consoleLog('exclusiveLandingPath', exclusiveLandingPath);
  }
  return {
    paths: exclusiveLandingPath,
    fallback: false,
  };
};

export const getStaticProps = async ({
  params: { region, language, innerPage },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchExclusivePageData(
    region,
    language,
    `sadhguru-exclusive/${innerPage}`
  );
  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
    },
  };
};
export default ExclusiveSubPage;
